
import { Dialog, DialogContent, DialogHeader } from "@components/common/dialog";
import { useModal } from "@stores/modal-store";
import { Separator } from "../common/separator";
import TopBar from "./top-bar";
import useTranslator from "@pma/hooks/use-translator";
import { getCurrentTimeFormatted } from "@pma/utils/helpers";
import Conversation from "./conversation";

const Chat = () => {
  const { locale } = useTranslator();
  const modal = useModal();

  const closeModal = () => {
    modal.onClose();
    modal.setContext(undefined);
    return;
  };

  return (
    <Dialog open={modal.isOpen && modal.context === "ai"} onOpenChange={closeModal}>
      <DialogContent className='overflow-auto rounded-[20px] sm:max-w-[900px]'>
        <DialogHeader>
          <TopBar />
        </DialogHeader>
        <Separator className='m-0 w-full' />

        <div className='flex items-center justify-center text-gray-400'>
          {getCurrentTimeFormatted(locale)}
        </div>
        <Conversation />
      </DialogContent>
    </Dialog>
  );
};

export default Chat;
